<template>
    <nav class="header-nav" :class="{active: navActive}" itemscope itemtype="SiteNavigationElement" @click="$emit('setNavActive')">
        <router-link to="/" @click.native="$scrollToTop">Accueil</router-link>
        <router-link to="/info/à-propos" @click.native="$scrollToTop">À propos</router-link>
        <!-- <router-link to="/info/centre-de-preuves-en-dermatologie" @click.native="$scrollToTop">Centre de Preuves</router-link> -->
        <router-link to="/info/nous-contacter" @click.native="$scrollToTop">Nous contacter</router-link>
    </nav>
</template>

<script>

export default {
  name: 'header-nav',
  props: ['navActive'],
}
</script>

<style lang="scss">
.header-nav {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    position: fixed;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    background-color: #F5F7FA;
    box-sizing: border-box;
    padding-left: 24px;
    z-index: 5;
    left: 100%;
    transition: 0.4s all ease;
    @include montserratMedium;

    &.active {
         left: 0;
     }

    a {
        display: flex;
        align-items: center;
        color:#390039;
        text-decoration: none;
        height: auto;
        font-size: rem(20px);
        line-height: rem(30px);
        font-weight: 700;
        justify-content: flex-start;
        width: 100%;
        padding: rem(20px) 0;
        position: relative;

        &::after {
            content: '';
            height: 1px;
            width: 100%;
            background: color(border);
            position: absolute;
            bottom: 0;
        }

        &:last-child::after {
            display: none;
        }

        &:hover, &:focus {
            color: color(blue);
            text-decoration: underline;
        }
    }

    @include mq($from: MD) {
        flex-direction: row;
        height: 100%;
        width: auto;
        position: relative;
        z-index: 0;
        padding: 0;
        left: 0;
        background-color:transparent;

        a {
            font-size: rem(12px);
            font-weight: 500;
            width: auto;
            padding: rem(5px) rem(20px);

            &::after {
                content: '';
                height: 100%;
                width: 1px;
                background: color(border);
                position: absolute;
                right: 0;
            }

            @include mq($from: LG) {
                font-size: rem(14px);
            }
        }
    }
}


</style>
